/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { HealthCheckEntry, HealthCheckEntryFromJSON, HealthCheckEntryFromJSONTyped, HealthCheckEntryToJSON } from "./";

/**
 *
 * @export
 * @interface HealthCheckResponse
 */
export interface HealthCheckResponse {
  /**
   *
   * @type {string}
   * @memberof HealthCheckResponse
   */
  status?: string | null;
  /**
   *
   * @type {Date}
   * @memberof HealthCheckResponse
   */
  timestamp?: Date;
  /**
   *
   * @type {{ [key: string]: HealthCheckEntry; }}
   * @memberof HealthCheckResponse
   */
  checks?: { [key: string]: HealthCheckEntry } | null;
}

export function HealthCheckResponseFromJSON(json: any): HealthCheckResponse {
  return HealthCheckResponseFromJSONTyped(json, false);
}

export function HealthCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCheckResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: !exists(json, "status") ? undefined : json["status"],
    timestamp: !exists(json, "timestamp") ? undefined : new Date(json["timestamp"]),
    checks: !exists(json, "checks")
      ? undefined
      : json["checks"] === null
        ? null
        : mapValues(json["checks"], HealthCheckEntryFromJSON),
  };
}

export function HealthCheckResponseToJSON(value?: HealthCheckResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: value.status,
    timestamp: value.timestamp === undefined ? undefined : value.timestamp.toISOString(),
    checks:
      value.checks === undefined
        ? undefined
        : value.checks === null
          ? null
          : mapValues(value.checks, HealthCheckEntryToJSON),
  };
}
